// removed by extract-text-webpack-plugin
module.exports = {"Home":"_2FJrY4pETWpELiaeIQKIAj","Error":"_2M_XvhaLqVMBOftXmKmJGF"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/Home.css
// module id = 245
// module chunks = 0